appSocial.filter('momentPipe', ['moment',
    function (moment) {

        return function (value, format, tz, param) {
            if (!value) {
                return '';
            }
            const _value = value.toString().length === 10 ? Number(value) * 1000 : value;
            const tzMoment = moment(_value);

            if (param && param === true) {
                return tzMoment.subtract(1, 'days').add(1, 'seconds').format(format);
            }
            return tzMoment.format(format);
        }
    }]);
